import {
    IConfigGeral,
    IConfigGeralPortal,
    IConfigGeralPortalAdmin,
    IMensagemTransferencia,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import {
    AtualizarConfigGeralPortalAdmService,
    AtualizarConfigGeralService,
    CadastrarMensagemTransferenciaService,
    GetConfigGeralService,
    ListarConfiguracoesGeraisService,
    ListarMensagemTransferenciaService,
    VerificarIntegracaoMetaService,
} from "../../../../Services/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralService";
import { ValidationErr } from "../../../../Validations/ValidationError";

import { Controller } from "../../../Controller";

export async function GetConfigGeralController() {
    return Controller(GetConfigGeralService());
}

export async function AtualizarConfigGeralController(
    requestBody: IConfigGeral
) {
    return Controller(
        AtualizarConfigGeralService(requestBody),
        "Configuração atualizada com sucesso"
    );
}

export async function ListarConfiguracoesGeraisController(ID_MODULO: number) {
    const response = await ListarConfiguracoesGeraisService(ID_MODULO)
        .then((response) => {
            const objFromList = response.data.reduce((obj, config) => {
                return {
                    ...obj,
                    [config.DS_CONFIGURACAO]: config,
                };
            }, {}) as IConfigGeralPortal;
            return objFromList;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return response;
}

export async function AtualizarConfigGeralPortalAdmController(
    data: Array<IConfigGeralPortalAdmin>
) {
    return Controller(AtualizarConfigGeralPortalAdmService(data));
}

export async function ListarMensagemTransferenciaController() {
    return Controller(ListarMensagemTransferenciaService());
}

export async function CadastrarMensagemTransferenciaController(
    requestBody: IMensagemTransferencia
) {
    return Controller(CadastrarMensagemTransferenciaService(requestBody));
}

export async function VerificarIntegracaoMetaController() {
    return Controller(VerificarIntegracaoMetaService());
}
